import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex items-center gap-2 px-4 py-2 mb-4 rounded-xl w-full",
  style: {"background":"linear-gradient(to right, #e2070b 25.826%, #f9a743 81.496%)"}
}
const _hoisted_2 = { class: "flex flex-col text-white" }
const _hoisted_3 = { class: "text-16px font-medium leading-normal tracking-[-0.32px]" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "text-16px font-bold leading-normal tracking-[-0.32px]" }, "DEX AI", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.shouldShow)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("img", {
          src: require('@/app/ui/assets/svg/dex-assesment/cpu-icon.svg'),
          alt: "CPU Icon",
          class: "shrink-0 w-10 h-10"
        }, null, 8, ["src"]),
        _createVNode("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("dexAssessment.assessedBy")), 1),
          _hoisted_4
        ])
      ]))
    : _createCommentVNode("", true)
}